// pages/FormViewerPage/services/formViewerService/funnelSnack.ts — event funnel Snack (split dari funnelEvents.ts)
import type { FunnelEventParams } from './funnelTypes';
import { alreadyFired } from './funnelSession';

// Tembak event funnel Snack (snaptr) — idempoten per sesi tab.
export function fireFunnelSnackEvent(
    pixelIds: string[],
    eventName: 'ADD_CART' | 'START_CHECKOUT',
    params: FunnelEventParams,
    sessionKey: string
): boolean {
    try {
        if (!pixelIds || pixelIds.length === 0) return false;
        if (alreadyFired(sessionKey)) return false;
        const snaptr = (window as any).snaptr;
        if (typeof snaptr !== 'function') return false;
        // snaptr global (tanpa init per pixel) — pixelIds sudah divalidasi di atas.
        snaptr('track', eventName, {
            content_name: params.content_name || 'Form',
            currency: 'IDR',
            ...(params.value !== undefined ? { price: params.value } : {}),
        });
        return true;
    } catch { return false; }
}
